import { API_URL } from "./auth-fetch";

const API_SPORTS_MEDIA_BASE = "https://media.api-sports.io/football";

export const toProxiedMediaUrl = (url: string): string =>
	url ? `${API_URL}/api/media/image?url=${encodeURIComponent(url)}` : url;

export const toPlayerPhotoUrl = (playerId: number): string =>
	toProxiedMediaUrl(`${API_SPORTS_MEDIA_BASE}/players/${playerId}.png`);
